import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'humanSize'
})
export class HumanSizePipe implements PipeTransform {

    transform(bytes: number): string {
        const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        let u = -1;
        const thresh = 1024;
        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }
        do {
            bytes /= thresh;
            ++u;
        } while (Math.abs(bytes) >= thresh && u < units.length - 1);
        return `${bytes.toFixed(1)} ${units[u]}`;
    }

}
